/**
 * Design-search result images live on the FluidityIQ CDN.
 * Pinecone metadata includes a `path` (relative to the CDN origin) for the matched image.
 */

export const DESIGN_SEARCH_CDN_BASE = "https://cdn.fluidityiq.ai";

export function getDesignSearchCdnBase(): string {
  return DESIGN_SEARCH_CDN_BASE;
}

/**
 * Absolute URL for a CDN-relative path from Pinecone metadata (`metadata.path`).
 * Leading slashes on `path` are normalized.
 * Any file extension is replaced with .jpg since the CDN serves JPG images.
 */
export function cdnImageUrlFromPath(path: string): string {
  const segment = path.trim().replace(/^\/+/, "");
  if (!segment) return DESIGN_SEARCH_CDN_BASE;
  // Replace any extension with .jpg
  const jpgSegment = segment.replace(/\.[^/.]+$/, ".jpg");
  return `${DESIGN_SEARCH_CDN_BASE}/${jpgSegment}`;
}
